import React from "react";
import styles from "./FixedLogoWithName.module.css";
import { TiStarFullOutline } from "react-icons/ti";// You can switch this icon if needed

const FixedLogoWithName = ({ label = "Label", color  }) => {
  return (
    <div className={styles.container}>
      <TiStarFullOutline  size={16} style={{ color: color }} />
      <span className={styles.label} style={{ color: color }}>
        {label}
      </span>
    </div>
  );
};

export default FixedLogoWithName;
